module.exports = __webpack_public_path__ + "img/stopwatch.ab8378ba.png";